export default function initExpandablePhotoGallery($) {
  var isExpanded = true;

  $(".expandable-photo-gallery-photos").each(function () {
    $(this).children("figure").slice(3).addClass("hidden");
    isExpanded = false;
  });

  $(".expandable-photo-gallery button").on("click", function () {
    const $gallery = $(this).closest(".expandable-photo-gallery");
    $gallery
      .find(".expandable-photo-gallery-photos figure")
      .slice(3)
      .toggleClass("hidden");
    isExpanded = !isExpanded;
    $(this).attr("aria-expanded", isExpanded);
    isExpanded ? $(this).addClass("hidden") : $(this).removeClass("hidden");
  });
}
